module.exports = __webpack_public_path__ + "static/media/logo-white.745368d9.svg";